export default __webpack_public_path__ + "static/media/aldaco.19a5c42c.jpg";